import {toCamelCase} from "@/tools/functions";

const state = {
    breads: [],
};
const actions = {
    pushBread({commit}, bread) {
        const index = state.breads.findIndex(({key}) => key === bread.key)
        if (index === -1) {
            bread.text = toCamelCase(bread.text)
            commit("commitBread", {bread});
        }
    },
    pullBread({commit}, key) {
        commit("pullBread", {key});
    },
    cleanBread({commit}) {
        commit("cleanBread");
    }
};

const getters = {
    getBread: state => {
        return state.breads;
    }
};

const mutations = {
    commitBread(state, {bread}) {
        state.breads.push(bread);
    },
    pullBread(state, {key}) {
        state.breads.splice(state.breads.findIndex((element) => element.key === key), 1);
    },
    cleanBread(state) {
        state.breads.splice(0,  state.breads.length);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
